import $ from 'jquery';

$(document).ready(function () {
  heroSectionBlock();
});
function heroSectionBlock() {
  $('.js-acf-acf-hero-section-block').each(function () {});
}
